<template>
    <div>
        <v-toolbar flat>
            <v-card elevation="0">
            <v-card-text>
                <div class="mb-2">Apply Rounding</div>
                <v-radio-group
                v-model="shippingOption.rounding"
                @change="updateRounding"
                row
                >
                    <v-radio
                        label="No Rounding"
                        :value="0"
                    ></v-radio>
                    <v-radio
                        label="Round Up"
                        :value="1"
                    ></v-radio>
                    <v-radio
                        label="Round Down"
                        :value="2"
                    ></v-radio>
                </v-radio-group>
            </v-card-text>
        </v-card>
            <v-spacer></v-spacer>
            <v-btn small color="primary" @click="openDialogBox({'shipping_option_id': shippingOption.id})">
                Add Pricing Rule
            </v-btn>
        </v-toolbar>

        <div v-if="selectedPricingRules.length > 0" class="m-3">
            <v-btn
                x-small
                class="white--text"
                color="#FF7033" @click="deleteItem(selectedPricingRules)">
                Delete Selected
            </v-btn>
        </div>

        <v-card elevation="0">
            <v-card-text>

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th width="40"></th>
                            <th v-if="rules.length > 1" width="40">
                                <v-checkbox
                                    v-model="selectAll" @change="toggleAll"
                                    class="ma-0 pa-0"
                                    hide-details
                                    dense
                                    >
                                </v-checkbox>
                            </th>
                            <th>Label</th>
                            <th>Rule</th>
                            <th width="200">Status</th>
                            <th width="220">Actions</th>
                        </tr>
                    </thead>
                    <TableBody
                        :sortEndpoint="baseUrl+'/sort'"
                        :items="rules"
                        @reordered="rules = $event"
                        >
                        <template v-slot:default="{ item }">
                            <td style="cursor: move">
                                <v-icon>mdi-drag</v-icon>
                            </td>
                            <td v-if="rules.length > 1">
                                <v-checkbox
                                    v-model="selectedPricingRules"
                                    :value="item.id"
                                    class="ma-0 pa-0"
                                    hide-details
                                    dense
                                    >
                                </v-checkbox>
                            </td>
                            <td>{{ item.label }}</td>
                            <td>
                                <v-chip
                                    v-for="(part, index) in makeRuleSummary(item)"
                                    :key="index"
                                    class="ma-1"
                                    small
                                    >
                                    {{ part }}
                                </v-chip>
                            </td>
                            <td>
                                <v-switch
                                    @change="updateStatus(item)"
                                    :disabled="isSaving"
                                    :loading="isSaving && item.id === rule.id"
                                    v-model="item.enabled"
                                    :label="item.enabled ? 'Enabled' : 'Disabled'"
                                    hide-details
                                    dense
                                    class="mt-0 d-inline-block" />
                            </td>
                            <td>
                                <v-btn x-small @click="duplicateItem(item)" :disabled="isDuplicating">Duplicate</v-btn>
                                <v-btn x-small @click="openDialogBox(item)">Edit</v-btn>
                                <v-btn x-small class="white--text" color="#FF7033" @click="deleteItem(item)">Delete</v-btn>
                            </td>
                        </template>
                    </TableBody>
                </table>

            </v-card-text>
        </v-card>

        <!-- Add/Edit Dialog -->
        <v-dialog v-model="updateFormDialog" max-width="80%">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Edit Pricing Rule</span>
                </v-card-title>
                <v-card-text>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="rule.label"
                                    label="Label"
                                    :error-messages="getLabelErrors"
                                    @blur="$v.rule.label.$touch()"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <v-radio-group
                                v-model="rule.type"
                                row
                                >
                                    <v-radio
                                        label="Markup"
                                        :value="0"
                                    ></v-radio>
                                    <v-radio
                                        label="Discount"
                                        :value="1"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field type="Number" v-model="rule.adjustment_value" :label="rule.type == 1 ? 'Discount':'Markup'"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-switch
                                    v-model="rule.percentage_based"
                                    label="Percentage Based"
                                    hide-details
                                    dense
                                    class="mt-0 ml-2 d-inline-block" />
                            </v-col>
                        </v-row>


                        <v-row class="mt-10">
                            <v-col cols="6">
                                <v-checkbox
                                    v-model="minShippingCheck"
                                    label="Apply Minimum Shipping Cost"
                                    hide-details
                                    dense
                                    class="mt-0 d-inline-block"
                                    @change="checkMinMaxShippingCost('min')"
                                    />
                                <v-text-field v-if="minShippingCheck" type="Number" v-model="rule.minimum_shipping_cost" label="Minimum Shipping Cost"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox
                                    v-model="maxShippingCheck"
                                    label="Apply Maximum Shipping Cost"
                                    hide-details
                                    dense
                                    class="mt-0 d-inline-block"
                                    @change="checkMinMaxShippingCost('max')"
                                    />
                                <v-text-field v-if="maxShippingCheck" type="Number" v-model="rule.maximum_shipping_cost" label="Maximum Shipping Cost"></v-text-field>
                            </v-col>
                        </v-row>

                        <Conditions :conditions="rule.conditions" :additionalFields="additionalFields" />
                    </v-container>
                </v-card-text>
                <v-card-actions class="sticky-bottom white">
                    <v-switch
                        v-model="rule.enabled"
                        class="mr-4"
                        label="Enabled">
                    </v-switch>
                    <v-spacer></v-spacer>
                    <v-btn small  @click="updateFormDialog=false">Close</v-btn>
                    <v-btn :disabled="isSaving" small color="primary" @click="savePricingRule">
                        <span v-if="isSaving">
                            <v-progress-circular
                                indeterminate
                                size="12"
                                width="2"
                                color="primary darken-3">
                            </v-progress-circular>
                            Saving...
                        </span>
                        <span v-else>Save</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <ConfirmationDialog
            action="put"
            ref="updateConfirmation"
            @on-cancel="shippingOption.rounding = selectedShippingOption.rounding"
        />


        <ConfirmationDialog
            action="delete"
            requestMethod="post"
            ref="deleteConfirmation"
            @post-confirm="fetchPricingRules"
        />

    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { EventBus } from '@/js/event-bus.js'
import { ShippingOptionStruct, ShippingOptionPricingRuleStruct } from './ShippingOptionStruct.js';
import ConfirmationDialog from './components/ConfirmationDialog';
import Conditions from './components/Conditions';
import TableBody from './components/TableBody';
import store from '@/js/store/index.js';
import { isArray } from 'lodash';
export default {

    props: {
        selectedShippingOption: {
            type: ShippingOptionStruct,
            required: true
        }
    },

    components: {
        ConfirmationDialog,
        Conditions,
        TableBody
    },

    validations: {
        rule: {
            label: { required },
        },
    },

    computed: {
        getLabelErrors() {
            const labelValidation = this.$v.rule.label;
            if (!labelValidation.$dirty) return [];
            return !labelValidation.required ? ['Label is required'] : [];
        },
    },

    data() {
        return {
            baseUrl: `/api/shipping-options/${this.selectedShippingOption.id}/pricing-rules`,
            isLoading: false,
            isSaving: false,
            shippingOption: new ShippingOptionStruct(this.selectedShippingOption),
            rules: [],
            rule: new ShippingOptionPricingRuleStruct({}),
            updateFormDialog: false,

            selectAll: false,
            selectedPricingRules: [],

            additionalFields: [
                { header: 'Route Fields' },
                {
                    'text': 'Route Data Field',
                    'value': 'route-data-field'
                },
                {
                    'text': 'Total Sell Price',
                    'value': 'total-sell-price'
                },
            ],

            minShippingCheck: false,
            maxShippingCheck: false,
            isDuplicating: false,
        };
    },
    created() {
        this.initialize();
    },

    methods: {
        initialize() {
            this.fetchPricingRules();
        },

        toggleAll() {
            if (this.selectAll) {
                this.selectedPricingRules = this.rules.map(item => item.id);
            } else {
                this.selectedPricingRules = [];
            }
        },

        fetchPricingRules() {
            this.isLoading = true;
            this.$http
                .get(`${this.baseUrl}`)
                .then(({ data }) => {
                    this.rules = data.data.map(rule => {
                        return new ShippingOptionPricingRuleStruct(rule);
                    }) ?? [];
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        openDialogBox(item) {
            this.rule = new ShippingOptionPricingRuleStruct(item);
            this.updateFormDialog = true;

            this.minShippingCheck = this.rule.minimum_shipping_cost !== null && this.rule.minimum_shipping_cost > 0;
            this.maxShippingCheck = this.rule.maximum_shipping_cost !== null && this.rule.maximum_shipping_cost > 0;
        },

        savePricingRule() {

            this.$v.$touch();

            if (this.$v.$invalid) {
                EventBus.$emit('show-error', 'Please complete the required fields.');
                return;
            }

            this.isSaving = true;

            const url = this.rule.id ? `${this.baseUrl}/${this.rule.id}` : this.baseUrl;
            const method = this.rule.id ? 'put' : 'post';

            // if new rule, set the order to the next available number, so that it can be sorted correctly
            if(method == 'post') {
                this.rule.order = this.rules.length ? Math.max(...this.rules.map(r => r.order ?? 0)) + 1 : 1;
            }


            this.$http
                .withClientId(store.getters['LRSettingsState/getShopifyUserId'])
                [method](url, this.rule)
                .then(({ data }) => {
                    this.fetchPricingRules();
                    this.updateFormDialog = false;
                    EventBus.$emit('show-success', 'Carrier and service saved successfully.');
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },

        deleteItem(item) {
            const itemsToDelete = [];
            if(isArray(item)) {
                this.$refs.deleteConfirmation.itemLabel = `${this.selectedPricingRules.length} Selected Pricing Rules`;
                itemsToDelete.push(...this.selectedPricingRules);
            } else {
                itemsToDelete.push(item.id);
                this.$refs.deleteConfirmation.itemLabel = `${item.label}`;
            }

            this.$refs.deleteConfirmation.open(`${this.baseUrl}/delete`, {pricing_rule_ids: itemsToDelete});
            this.deletedItems = itemsToDelete;
        },

        updateRounding() {
            this.$refs.updateConfirmation.itemLabel = `Rounding`;
            const endpoint = `/api/shipping-options/${this.shippingOption.integration_id}/${this.shippingOption.id}`;
            const data = { id: this.shippingOption.id, rounding: this.shippingOption.rounding, statusUpdate: true };
            this.$refs.updateConfirmation.open(endpoint, data);
        },

        updateStatus(item) {

            this.rule = new ShippingOptionPricingRuleStruct(item);

            this.isSaving = true;

            const payload = {
                id: item.id,
                enabled: item.enabled,
                statusUpdate: true
            };

            const action = item.enabled ? 'enabled' : 'disabled';

            this.$http
                .withClientId(store.getters['LRSettingsState/getShopifyUserId'])
                .put(`${this.baseUrl}/${item.id}`, payload)
                .then(({ data }) => {
                    EventBus.$emit('show-success', `Pricing rule ${action} successfully.`);
                    this.$emit('post-save');
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },

        makeRuleSummary(rule) {
            const summary = [];

            if(rule.adjustment_value != 0 && rule.adjustment_value != ''){
                let adjustment = '';
                if (rule.percentage_based) {
                    adjustment = `${rule.adjustment_value}% `
                } else {
                    adjustment = `\$${rule.adjustment_value} `;
                }
                adjustment += rule.type == 1 ? 'Discount' : 'Markup';
                summary.push(adjustment);
            }

            if(rule.minimum_shipping_cost > 0) {
                summary.push(`\$${rule.minimum_shipping_cost} Min shipping`);
            }

            if(rule.maximum_shipping_cost > 0) {
                summary.push(`\$${rule.maximum_shipping_cost} Max shipping`);
            }

            if(rule.condition_count > 1){
                summary.push('With conditions');
            } else if (rule.condition_count > 0){
                summary.push('With condition');
            }

            return summary;
        },

        duplicateItem(item) {
            this.isDuplicating = true;

            const duplicate = new ShippingOptionPricingRuleStruct(item);
            duplicate.id = '';
            duplicate.label = `${item.label} (Copy)`;
            duplicate.enabled = false;
            duplicate.order = this.rules.length ? Math.max(...this.rules.map(r => r.order ?? 0)) + 1 : 1;

            this.$http
                .withClientId(store.getters['LRSettingsState/getShopifyUserId'])
                .post(this.baseUrl, duplicate)
                .then(() => {
                    EventBus.$emit('show-success', 'Pricing rule duplicated successfully.');
                    this.fetchPricingRules();
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                })
                .finally(() => {
                    this.isDuplicating = false;
                });
        },

        checkMinMaxShippingCost(type) {
            if(type === 'min' && !this.minShippingCheck) {
                this.rule.minimum_shipping_cost = null;
            }
            if(type === 'max' && !this.maxShippingCheck) {
                this.rule.maximum_shipping_cost = null;
            }
        }

    }

}
</script>